import { render, staticRenderFns } from "./DriverView.vue?vue&type=template&id=0bfc5b0d&scoped=true"
import script from "./DriverView.vue?vue&type=script&lang=js"
export * from "./DriverView.vue?vue&type=script&lang=js"
import style0 from "./DriverView.vue?vue&type=style&index=0&id=0bfc5b0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfc5b0d",
  null
  
)

export default component.exports